import { createApp } from 'vue'; // Import createApp
import App from './App.vue';
import router from './router';

// Import global styles
import './assets/styles/global.css';

const app = createApp(App); // Create the app instance

app.use(router); // Use router

app.mount('#app'); // Mount the app